export default __webpack_public_path__ + "static/media/3-1820x480多多.2ac2ce40.jpg";